'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 13, viewBox: "0 0 12 13", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.52 1.5h-.023c-.395 0-.724 0-.994.017a2.7 2.7 0 0 0-.805.156 2.6 2.6 0 0 0-1.493 1.494c-.1.258-.139.524-.157.805-.017.27-.017.6-.017.994v2.076c0 .854 0 1.565.076 2.13.08.594.256 1.13.686 1.56s.965.605 1.56.685c.564.076 1.275.076 2.13.076h2.169c.667 0 1.18.001 1.614-.157a2.6 2.6 0 0 0 1.552-1.553c.158-.434.158-.947.157-1.613v-.123a.7.7 0 1 0-1.4 0c0 .849-.01 1.087-.072 1.257a1.2 1.2 0 0 1-.717.716c-.17.062-.408.073-1.256.073H5.53c-.915 0-1.531-.002-1.991-.063-.44-.06-.63-.162-.757-.288-.127-.127-.23-.318-.288-.757-.062-.46-.064-1.077-.064-1.992V4.988c0-.422 0-.707.015-.927.013-.215.038-.321.065-.392a1.2 1.2 0 0 1 .69-.689c.07-.027.176-.052.391-.066.22-.014.505-.014.927-.014a.7.7 0 1 0 0-1.4m1.304 5.236-.286.02.049-.282.12-.68 2.862-2.69a.617.617 0 1 1 .845.9l-2.85 2.678zm-1.438 1.06c.25.277.571.344.807.36.207.015.456-.003.695-.02l.038-.003.974-.072a.74.74 0 0 0 .452-.198l3.02-2.838a2.017 2.017 0 1 0-2.762-2.94L4.588 4.923a.74.74 0 0 0-.22.409l-.16.896-.006.038c-.042.236-.086.482-.092.689-.008.236.026.562.276.84", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
